import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'vds-content-text',
  styleUrl: 'vds-content-text.scss',
  shadow: true,
})
export class VdsContentText {
  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  /**
    * Controls wether or not the downloads should be displayed
    */
  @Prop() showDownloads = false;

  /**
   * Controls wether or not the call-to-action buttons should be displayed
   */
  @Prop() showCtas = false;

  /**
   * Controls the space between media slot and headline
   * true = less space between headline and media slot
   */
  @Prop() fullWidth = false;

  /**
   * Controls the visibility of the media-mobile and media-desktop slots
   */
  @Prop() showIcon = false;

  /**
   * Removes space limitation of the media slot to allow larger icons
   */
  @Prop() largeIcon = false;

  render() {
    const { headline, showIcon, largeIcon, showCtas, showDownloads, subline, fullWidth } = this;

    return (
      <Host>
        <div class={{
          "flex": true,
          "flex-col sm:flex-row": largeIcon
        }}>

        { showIcon && (
            <div
              class={{
                'flex-initial flex items-center text-berry': true,
                'ml-0 mr-4 sm:ml-0 sm:mr-6': fullWidth,
                'mx-4 sm:mx-10': !fullWidth,
                "justify-center": !largeIcon
              }}>
                <div class={{
                  "flex max-h-[90px] sm:max-h-[160px] overflow-hidden": true,
                  "max-w-[90px] sm:max-w-[160px]": !largeIcon,
                  "mb-5 sm:mb-0": largeIcon
                }}>
                    <slot name="media-mobile"></slot>
                    <slot name="media-desktop"></slot>
                </div>
            </div>
          )}

          <div class="flex-auto min-w-0">
            <div class="flex flex-col justify-center h-full w-full">
              <h2 class="font-heavy text-grey text-h2-mobile sm:text-h2-desktop uppercase break-words" innerHTML={headline}></h2>
              <h3 class="text-s2-mobile sm:text-s2-desktop text-berry uppercase mt-2 hidden sm:block break-words" innerHTML={subline}></h3>
            </div>
          </div>

        </div>

        <div class="flex sm:hidden justify-center">
          <h3 class="text-s2-mobile sm:text-s2-desktop text-berry uppercase mt-2" innerHTML={subline}></h3>
        </div>

        <slot name="copy"></slot>

        {showDownloads && <slot name="downloads"></slot>}

        {showCtas && (
          <div class="flex flex-wrap flex-row justify-start gap-y-3 gap-x-6">
            <slot name="ctas"></slot>
          </div>
        )}
      </Host>
    );
  }
}
